import ParticlesBackground from "../components/ParticlesBackground";
import Navigation from '../components/Navigation';
import HomepageHeroSection from '../components/HomepageHeroSection';
import Services from '../components/Services';
import Highlights from '../components/Highlights';
import FeaturedWork from '../components/FeaturedWork';
import WhyUs from '../components/WhyUs';
import CTA from '../components/CTA';
import FooterCentered from '../components/FooterCentered';
import { motion } from "framer-motion";

export default function Home() {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="grain-overlay"
        >
            <ParticlesBackground id="tsparticles" />
            {/* <Navigation /> */}
            <HomepageHeroSection />
            {/* <FeaturedWork />
            <Services />
            <Highlights />
            <WhyUs />
            <CTA /> */}
            <FooterCentered />
        </motion.div>
    )
}
